/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, planned: NonNullable<unknown> }} Wrapped_Sessions_Of_PlannedInputs */

const en_us2_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 workout`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.planned} workouts`)
	
};

const pt_br2_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} treinos`)
	
};

const es_419_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} entrenamientos`)
	
};

const pt_pt2_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} treinos`)
	
};

const fr_fr2_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} sur 1 séance`);
	return /** @type {LocalizedString} */ (`${i?.done} sur ${i?.planned} séances`)
	
};

const de_de2_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Training`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.planned} Trainings`)
	
};

const it_it2_wrapped_sessions_of_planned = /** @type {(inputs: Wrapped_Sessions_Of_PlannedInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 allenamento`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.planned} allenamenti`)
	
};

/**
* | planned | output |
* | --- | --- |
* | "1" | "{done} of 1 workout" |
* | * | "{done} of {planned} workouts" |
*
* @param {Wrapped_Sessions_Of_PlannedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_sessions_of_planned = /** @type {((inputs: Wrapped_Sessions_Of_PlannedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Sessions_Of_PlannedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_sessions_of_planned(inputs)
	if (locale === "es-419") return es_419_wrapped_sessions_of_planned(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_sessions_of_planned(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_sessions_of_planned(inputs)
	if (locale === "de-DE") return de_de2_wrapped_sessions_of_planned(inputs)
	if (locale === "it-IT") return it_it2_wrapped_sessions_of_planned(inputs)
	return en_us2_wrapped_sessions_of_planned(inputs)
});
export { wrapped_sessions_of_planned as "wrapped.sessions_of_planned" }